import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import useAnalyticsEventTracker from '@shared/hooks/analytics/useAnalyticsEventTracker';
import { MuiLink } from '@shared/ui-kit/links/MuiLink/MuiLink';

const to = 'https://calendly.com/support-rvm/30min';
export const BookDemoBlock = () => {
  const { t } = useTranslation();
  const gaEventTracker = useAnalyticsEventTracker();

  return (
    <Box display="flex" gap="8px" alignItems="center" width="100%" height="100%" justifyContent="center">
      <Box display="flex" alignItems="center" gap="8px">
        <Typography color={(theme) => theme.palette.case.neutral.n600} variant="t14m">
          {t('onboardingSetup.helpFast')}
        </Typography>
        <Box
          onClick={() =>
            gaEventTracker({
              event: AnalyticsEventEnum.onboardingChecklistBookADemoSelected,
            })
          }
        >
          <MuiLink to={to} target="_blank">
            {t('onboardingSetup.bookDemo')}
          </MuiLink>
        </Box>
      </Box>
    </Box>
  );
};

export default BookDemoBlock;
